const Ethereum = () => (
    <svg
        width='40'
        height='40'
        viewBox='0 0 40 40'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='ethereum'
    >
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM20.0767 24.7051L27.9957 20.025L20.0767 6.88525L12.1577 20.025L20.0767 24.7051ZM28 21.5264L20.0767 32.6842L12.1577 21.5264L20.0767 26.2023L28 21.5264Z'
            fill='white'
        />
    </svg>
);

export default Ethereum;
